import { Box, Stack, useTheme } from "@mui/material"
import SimpleBar from "simplebar-react"
import _ from "lodash"

export const HorizontalScrollPane = ({ children, sx, ...props }) => {
  const theme = useTheme()
  const styleOverrides = _.get(
    theme,
    "components.HorizontalScrollPane.styleOverrides",
    {}
  )
  const { root, listWrapper } = styleOverrides
  return (
    <Box sx={root}>
      <SimpleBar>
        <Stack direction="row" sx={{ ...listWrapper, ...sx }} {...props}>
          {children}
        </Stack>
      </SimpleBar>
    </Box>
  )
}
